// Shared frontend subscription identifiers.
// Rails remains the source of truth for checkout amounts; these types mirror
// GET /api/v1/stripe/pricing.

export type Duration = "1m" | "1y";

export type PricePhase = "launch" | "first" | "returning" | "standard";

export type PlanPrices = Readonly<Record<Duration, number>>;

export interface PricingOffer {
  readonly phase: PricePhase;
  /** When the 3-day launch price ends; null for visitors and after day 3. */
  readonly ends_at: string | null;
  readonly prices: PlanPrices;
  readonly next_prices: PlanPrices | null;
  readonly standard_prices: PlanPrices;
  /** Annual price for approved creators and creator referral codes. */
  readonly creator_annual_cents: number | null;
  readonly subscribed: boolean;
}

/** Whole-dollar prices print without cents ("$98"); others keep two places. */
export function formatUsd(cents: number): string {
  const dollars = cents / 100;
  return `$${Number.isInteger(dollars) ? dollars : dollars.toFixed(2)}`;
}

/** Annual savings against paying the same phase's monthly price for a year. */
export function annualSavingsPercent(prices: PlanPrices): number {
  return Math.round((1 - prices["1y"] / (prices["1m"] * 12)) * 100);
}

export function annualPerMonth(cents: number): string {
  return formatUsd(Math.round(cents / 12));
}
